'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getUnitType = function getUnitType(settings) {
  var isFlat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isFlat) {
    return '';
  }
  if (settings.units && settings.units.surfHeight) {
    return settings.units.surfHeight.toLowerCase();
  }
  return 'm';
};

exports.default = getUnitType;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/helpers/getUnitType.js
// module id = 707
// module chunks = 11